import axios from "axios";
import configData from "../config"
let api_url = configData.API_URL || "http://localhost:8080/"
const config = {
    headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("token")
    }
};

class DataServ {

    addCoinDB(coinId, coinName, coinSymbol, lower, upper) {
        console.log(config)
        return axios.post(api_url + "newcoin", { coinId: coinId, coinSymbol: coinSymbol, coinName: coinName, upper: upper, lower: lower }, config)
            .then(res => {
                console.log(res.data)
                return res.data
            })
    }

    updateCoinDB(coinId, coinName, coinSymbol, lower, upper) {
        return axios.post(api_url + "updatecoin", { coinId: coinId, coinSymbol: coinSymbol, coinName: coinName, upper: upper, lower: lower }, config)
            .then(res => {
                console.log(res.data)
                return res.data
            })
    }

    addNotificationDB(coinId, coinName, limit, current, relation, read) {
        return axios.post(api_url + "addnotification", { coinId: coinId, coinName: coinName, limit: limit, current: current, relation: relation,read:read }, config)
            .then(res => {
                return res.data
            })
    }

    getLiveRate(coinId) {
        return axios.get(api_url + "getcurrency", {
            params: {
                currencyID: coinId
            }
        }).then(res => {
            return res.data
            // returns straight data
        })
    }

    getWeekRate(coinId) {
        return axios.get(api_url + "getweek", {
            params: {
                currencyID: coinId
            }
        }).then(res => {
            return res.data
            //returns direct array
        })
    }

    getMonthRate(coinId) {
        return axios.get(api_url + "getmonth", {
            params: {
                currencyID: coinId
            }
        }).then(res => {
            return res.data
            // returns direct array
        })
    }
}

export default new DataServ()